<script lang="ts">
    import Esi from '@shared/components/esi/Esi.svelte';

    const { requests }: { requests: string[] } = $props();
</script>

{#each requests as src}
    <Esi {src} />
{/each}
